import { render } from "./InformationPopup.vue?vue&type=template&id=5f9fa466&ts=true"
import script from "./InformationPopup.vue?vue&type=script&lang=ts"
export * from "./InformationPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__